var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSimbolo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20.00 18.00 220.23 218.00",
    role: "img",
    "aria-label": "Rivals Base",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rivals Base") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96.32 24.00 L216.32 24.00 L187.68 62.00 L202.92 100.00 L146.92 100.00 L189.43 206.00 L158.73 206.00 L125.04 122.00 L109.04 122.00 L94.23 206.00 L64.23 206.00 Z M117.15 76.00 L177.07 76.00 L165.68 62.00 L182.01 48.00 L122.09 48.00 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FACC15",
    d: "M30.23 206.00 L234.23 206.00 L230.00 230.00 L26.00 230.00 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimbolo);
export default __webpack_public_path__ + "static/media/logo-simbolo.1c4f61bf479ce18811337e1384ef9d59.svg";
export { ForwardRef as ReactComponent };